import { GetOcrTradesApi } from "@/features/accounts/ocr/services/get-trades-api";
import { GetOcrTradesRequestModel } from "@/features/accounts/ocr/services/get-trades-model";

/// OCR明細一覧取得処理
export class GetOcrTradesService {
  private getOcrTradesApi = new GetOcrTradesApi();
  /**
   * OCR明細一覧取得API実行
   */
  public async getOcrTrades(param: GetOcrTradesRequestModel) {
    return await this.getOcrTradesApi.getOcrTrades(param);
  }
}
